// Source: https://github.com/Shopify/dawn/issues/2166
(function handleCartRefreshOnBFCache(){
    window.addEventListener('pageshow', async (event) => {
        if (typeof refreshCart !== 'function') {
            return;
        }

        try {
            const miniCartElements = document.querySelectorAll('.mini_cart');
            if (event.persisted && miniCartElements) {

                minicart.handleInteractivity(false);

                const cart = await fetch('/cart.js');
                
                if (!cart.ok) {
                    throw new Error('Network response was not ok');
                }

                const cartData = await cart.json();
                refreshCart(cartData);

                // Add a small delay to ensure cart count update is noticeable to the end user
                setTimeout(() => {
                    minicart.handleInteractivity(true);
                }, 1000);
            }
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
            window.location.reload();
        }
    });
})(); 